// CancellationPolicy.jsx
import React from "react";
import Layout from "../../components/user/Layout";

const CancellationPolicy = () => {
  return (
    <Layout>
      <div className="cancellation-policy py-22 ps-40 pe-40">
        <h2 className="d-flex justify-content-center fw-bold">Cancellation Policy</h2>
        <p>
          The following cancellation policy applies to items purchased online through Power Trading Mobile App and Site:
        </p>

        <section>
          <ul>
            <li>
              The order can be cancelled by the customer (through support number) <strong>before the order has been dispatched</strong> from the outlet. Any cancellation request placed after this will be <strong>rejected</strong>, and the customer shall take delivery of the material.
            </li>
            <li>
              In case the cancellation request has been accepted, the amount will be transferred to the customer’s bank account within <strong>15 working days</strong>.
            </li>
            <li>
              Please note that there may be certain orders that we are <strong>unable to accept</strong> and must cancel due to technical or operational reasons.
            </li>
            <li>
              We reserve the right, at our sole discretion, to <strong>refuse or cancel any order for any reason</strong>. We will contact you if all or any portion of your order is cancelled or if additional information is required to accept your order.
            </li>
            <li>
              If your order is cancelled <strong>after your bank account has been charged</strong>, the said amount will be <strong>reversed</strong> back to your bank account.
            </li>
          </ul>
        </section>
      </div>
    </Layout>
  );
};

export default CancellationPolicy;